import { render } from "./MagneticBackgroud.vue?vue&type=template&id=1cf8ee82&scoped=true"
import script from "./MagneticBackgroud.vue?vue&type=script&lang=js"
export * from "./MagneticBackgroud.vue?vue&type=script&lang=js"

import "./MagneticBackgroud.vue?vue&type=style&index=0&id=1cf8ee82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf8ee82"]])

export default __exports__